<div class="tabletView">
	@if (simDeviceViewService.layout === LayoutVariants.TABLET_PORTRAIT) {
		<div>
			<img class="rotateLandscape" src="{{ baseHref }}/assets/pics/tabletRotation.svg" alt="rotated Tablet" />
			<p class="txt1">
				{{ T.UNSUPPORTED_TABLET_TEMPLATE_ROTATION_DEVICE | translate }}
			</p>
			<p class="txt2">
				{{ T.UNSUPPORTED_TABLET_TEMPLATE_NOT_SUPPORTED_FOR_VIEW | translate }}
			</p>
		</div>
	}
	@if (simDeviceViewService.layout === LayoutVariants.TABLET_LANDSCAPE) {
		<div>
			<img class="rotatePortrait" src="{{ baseHref }}/assets/pics/tabletLandscape.svg" alt="rotated Tablet" />
			<p class="txt1">
				{{ T.UNSUPPORTED_TABLET_TEMPLATE_ROTATION_DEVICE_LANDSCAPE | translate }}
			</p>
			<p class="txt2">
				{{ T.UNSUPPORTED_TABLET_TEMPLATE_NOT_SUPPORTED_FOR_VIEW_LANDSCAPE | translate }}
			</p>
		</div>
	}
</div>
